import { Pipe, PipeTransform } from '@angular/core'
import { WorkOrderType } from '@wm-front/admin/graphql'

declare const $localize: any

@Pipe({
  name: 'workOrderType',
})
export class WorkOrderTypePipe implements PipeTransform {
  public transform(value: WorkOrderType): string {
    switch (value) {
      case WorkOrderType.Shutdown:
        return $localize`:@@filtersCatalogManShutdownWorkOrderTypeLabel:Mise à l'arrêt`
      case WorkOrderType.Callout:
        return $localize`:@@filtersCatalogManCalloutWorkOrderTypeLabel:Intervention`
      case WorkOrderType.Repair:
        return $localize`:@@filtersCatalogManRepairWorkOrderTypeLabel:Réparation`
      default:
        return ''
    }
  }
}
